import { environment } from '../environments/environment';

const WP_BASE_URL = environment.wpBaseUrl;
export const API_BASE_URL = environment.apiBaseUrl;
const API_BASE_PATH = environment.apiBasePath;
const AUTH_BASE_PATH = environment.authBasePath;
const API_NOT_EXTRANET_PATH = environment.apiNotExtranet;
export const MATRICULA_PATH = environment.matrPath;
//const API_BASE_CHECKOUT = '/checkout-api';
const API_BASE_CHECKOUT = environment.checkoutBasePath!=null ? environment.checkoutBasePath : environment.production === 'true' ? '/checkout-api' : '/checkout-homolog';
// const API_MATRICULA_PATH = environment.apiMatriPath;
const API_MATRICULA_PATH = '/matricula-api';

export const API_BASE_KEY = environment.apiBaseKey;
export const RECAPTCHA_KEY = environment.recaptchaKey;
export const ANALYTICS_KEY = environment.analyticsKey;
export const CHECKOUT_KEY = environment.checkoutKey;
export const CHECKOUT_KEY_POS = environment.checkoutKeyPos;
export const HOST = environment.ceumaHost;

export const BASE = environment.base;

export const WP_API_URL = WP_BASE_URL + '/wp-json/wp/v2';
export const WP_API_POSTS = WP_API_URL + '/posts';
export const WP_API_TAGS = WP_API_URL + '/tags';
export const WP_API_CURSOS = WP_API_URL + '/cursos';
export const WP_API_CURSOS_POS_GRADUACAO = WP_BASE_URL + '/wp-json/wp/v3';
export const WP_PAGINAS_BASE = 'paginas';

export const WP_NOTICIAS_BASE = 'universidade/noticias';
export const CATEGORIA_HOME = '2';
export const AUTH_BASE_URL = environment.authPath;
export const CEUMA_URL_API = API_BASE_URL + API_BASE_PATH;
export const CEUMA_URL_AUTH_API = AUTH_BASE_URL + AUTH_BASE_PATH;
export const CEUMA_URL_BOLETO = API_BASE_URL + `/${environment.loginContexto=='CESUP'||environment.loginContexto=='CEUPI'? `Servicos${environment.loginContexto.substr(0,1).concat(environment.loginContexto.substr(1).toLowerCase())}`:'ServicosOnline'}/servicosFinanceiro`;
export const CEUMA_URL_BOLETO_VESTIBULAR = `${CEUMA_URL_BOLETO}/gerarBoletoV?token=${API_BASE_KEY}`;
export const CEUMA_URL_BOLETO_MATRICULA = `${API_NOT_EXTRANET_PATH}/${environment.loginContexto!='CEUPI'? 'ServicosOnline' : 'ServicosGalileo'}/servicosFinanceiro/getBoletoMatriculaGraduacao?token=${'cd15694f775ae81cda5d336ec0948789'}`;
export const CEUMA_URL_BOLETO_POSGRADUACAO = `${API_NOT_EXTRANET_PATH}/ServicosOnline/servicosFinanceiro/getBoletoInscricaoPosGraduacao?token=${'93c5c81497dd2d2e6123d55dcdf366a4'}`;
export const CEUMA_URL_CHECKOUT = API_BASE_URL + API_BASE_CHECKOUT;
export const CEUMA_URL_MATRICULA = MATRICULA_PATH + API_MATRICULA_PATH;
export const CEUMA_URL_POS_GRADUACAO = API_BASE_URL + '/pos-graduacao-api/posGraduacao';
export const CEUMA_URL_VALIDA_DOCUMENTOS = environment.validacaoDocumentosBasePath + '/validacao-diploma-api';
export const CEUMA_URL_CONSULTA_EMAIL = `${AUTH_BASE_URL}/bigbrain-api`;
export const CEUPI_URL_BOLETO = `http://www.ceuma.br/ServicosGalileo/servicosFinanceiro/gerarBoletoV?token=${'25231f2bd30c3c3d490e1e9a03729f94'}`;
//export const REMATRICULA_PATH = environment.rematriculaPath;

export const SISTEMAS = [
  {codigoSistema: 1, nomeSistema: 'VESTIBULAR', urlBoleto: CEUMA_URL_BOLETO_VESTIBULAR},
  {codigoSistema: 2, nomeSistema: 'MATRICULA', urlBoleto: CEUMA_URL_BOLETO_MATRICULA},
  {codigoSistema: 4, nomeSistema: 'MATRICULA', urlBoleto: CEUMA_URL_BOLETO_MATRICULA},
  {codigoSistema: 5, nomeSistema: 'POSGRADUACAO', urlBoleto: CEUMA_URL_BOLETO_POSGRADUACAO},
  {codigoSistema:99, nomeSistema: 'VESTIBULAR_CEUPI', urlBoleto: CEUPI_URL_BOLETO}
];

export const LOGIN_CONTEXTO = environment.loginContexto;

export const PDF_API_URL = 'https://www.extranet.ceuma.br/vestibular-pdf';


// FLAGS
export const FLAG_POS_GRADUACAO =  environment.flagPosGraduacao;
